module.exports = __webpack_public_path__ + "fonts/ralewayextrabold.b1127e0.woff2";